module.exports = __webpack_public_path__ + "media/scholarship_winners/daniel-m-9a5f1f01.png";